// extracted by mini-css-extract-plugin
export default {"form":"BasicInfo_form__bDqaP","textArea":"BasicInfo_textArea__a4aaW"};